import React, { useState, useEffect } from 'react';
import { Radio } from 'antd';
import { getFirestore, collection, query, where, getDocs, doc, updateDoc, getDoc } from "firebase/firestore";
import { showSuccessNotification, showWarningNotification, showErrorNotification } from '../../../utils/notifications';
import MediumModal from '../../../components/Components/Modals/MediumModal';

function AddNewBadge({
    isVisible,
    onClose,
    productId,
    productData
}) {
    const [selectedBadgeId, setSelectedBadgeId] = useState('');
    const [availableBadges, setAvailableBadges] = useState([]);
    const db = getFirestore();

    // Carica i badge esistenti quando la modale viene aperta
    useEffect(() => {
        if (isVisible) {
            fetchExistingBadges();
        }
    }, [isVisible]);

    // Resetta gli stati quando la modale viene chiusa
    useEffect(() => {
        if (!isVisible) {
            setSelectedBadgeId('');
        }
    }, [isVisible]);

    // Funzione per caricare i badge esistenti
    const fetchExistingBadges = async () => {
        try {
            const q = query(
                collection(db, "Tags"),
                where("group", "==", "Featured")
            );
            const querySnapshot = await getDocs(q);
            const badges = querySnapshot.docs.map(doc => ({
                id: doc.id,
                name: doc.data().name
            }));
            setAvailableBadges(badges);
        } catch (error) {
            console.error("Errore nel recupero dei badge:", error);
            showErrorNotification("Errore", "Errore nel recupero dei badge");
        }
    };

    // Funzione per gestire l'aggiunta del badge selezionato
    const handleAddExistingBadge = async () => {
        try {
            if (!selectedBadgeId) {
                showWarningNotification("Attention", "Select a badge to add");
                return;
            }

            // Ottieni i dati più recenti del prodotto direttamente dal database
            const productRef = doc(db, "Products", productId);
            const productSnapshot = await getDoc(productRef);

            if (!productSnapshot.exists()) {
                showErrorNotification("Error", "Product not found");
                return;
            }

            // Use the most recent product data
            const currentProductData = productSnapshot.data();
            const currentCategories = currentProductData.list_tags || [];

            // Verifica se il badge è già presente nell'array list_tags
            if (currentCategories.includes(selectedBadgeId)) {
                showWarningNotification("Attention", "This badge has already been added to the product");
                return;
            }

            // Aggiungi il nuovo badge all'array esistente
            const updatedCategories = [...currentCategories, selectedBadgeId];
            await updateDoc(productRef, { list_tags: updatedCategories });

            showSuccessNotification("Save successful", "Badge added successfully!");

            // Resetta gli stati
            setSelectedBadgeId('');

            // Chiudi la modale e notifica il componente padre dell'aggiornamento
            onClose(true);
        } catch (error) {
            console.error("Error in adding the badge:", error);
            showErrorNotification("Error", "Error in adding the badge");
        }
    };

    return (
        <MediumModal
            title="Add Existing Badge"
            visible={isVisible}
            onClose={() => onClose(false)}
            onConfirm={handleAddExistingBadge}
            confirmText="Add"
            cancelText="Cancel"
            width={700}
        >
            <Radio.Group
                style={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                    gap: '8px'
                }}
                value={selectedBadgeId}
                onChange={e => setSelectedBadgeId(e.target.value)}
            >
                {availableBadges.map(badge => (
                    <Radio
                        key={badge.id}
                        value={badge.id}
                        style={{
                            padding: '8px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f2f5',
                            textAlign: 'center'
                        }}
                    >
                        {badge.name}
                    </Radio>
                ))}
            </Radio.Group>
        </MediumModal>
    );
}

export default AddNewBadge;
